var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns is-multiline is-mobile"
  }, _vm._l((_vm.objects), function(object) {
    return _c('a', {
      key: _vm.chapter.shortname + '-' + object.id,
      staticClass: "column is-half-mobile is-one-third-tablet is-one-quarter-desktop",
      on: {
        "click": function($event) {
          _vm.$emit('open-details', object)
        }
      }
    }, [_c('ArchiveItem', {
      attrs: {
        "item": object
      }
    })], 1)
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36f09a39","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ArchiveGrid.vue
// module id = 8fuB
// module chunks = 0